import React, { Component } from "react";
import "./MAMCAEvaluation.css";
import Cookie from 'js-cookie';
import {
    message, ConfigProvider, Divider,
    Table, Empty, Spin,
    Modal, Button, Form, Slider, Tabs,
    Radio, Steps, Row, Col, Icon,
    Menu, Dropdown, Popconfirm, Upload,
    Typography, Result
} from 'antd';
import { Link } from "react-router-dom";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import AHP from '../ahp'

var QRCode = require('qrcode.react');

const { Text, } = Typography;
const TabPane = Tabs.TabPane;
//create publish modal
const PublishForm = Form.create({ name: 'publish_form_in_modal' })(
    // eslint-disable-next-line
    class extends Component {
        render() {
            const {
                visible, onCancel, onCreate, actor, surveyLink
            } = this.props; //read all the property send from criteria
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Survey link page"
                    // okText="Close"
                    onCancel={onCancel}
                    onOk={onCreate}
                >
                    <Result
                        status="success"
                        title={`Here is the alternative appraisal survey link for stakeholder group: ${actor}`}
                        subTitle={`Go to this link or scan the QR code: ${surveyLink}`}
                        extra={[
                            <h4 key="QR">QR code</h4>,
                            <QRCode key="QRCode" value={surveyLink} />,
                        ]}
                    />
                </Modal>
            );
        }
    }
);
//create AHP modal
const AHPForm = Form.create({ name: 'form_in_modal' })(

    // eslint-disable-next-line
    class extends Component {
        render() {

            const {
                visible, onCancel, onCreate, form, projectAlternatives, criteria, ahpNext, ahpPrevious, ahpstep, ahpData
            } = this.props; //read all the property send from criteria
            const marks = {
                '-8': '9',
                '-7': '8',
                '-6': '7',
                '-5': '6',
                '-4': '5',
                '-3': '4',
                '-2': '3',
                '-1': '2',
                '-0': '1',
                '1': '2',
                '2': '3',
                '3': '4',
                '4': '5',
                '5': '6',
                '6': '7',
                '7': '8',
                '8': '9'
            };
            var evaluationCriteria = []
            criteria.forEach(obj => {
                if (obj.subCriteria && obj.subCriteria.length !== 0) {
                    if (obj.subCriteria.length === 1) {
                        var nc = JSON.parse(JSON.stringify(obj.subCriteria[0]));
                        nc["criteriaName"] = nc.subCriteriaName
                        nc["criteriaWeight"] = nc.subCriteriaWeight
                        delete nc["subCriteriaName"];
                        delete nc["subCriteriaWeight"]
                        evaluationCriteria.push(nc)
                    }
                    else {
                        for (var s in obj.subCriteria) {
                            var mnc = JSON.parse(JSON.stringify(obj.subCriteria[s]))
                            mnc["criteriaName"] = mnc.subCriteriaName
                            mnc["criteriaWeight"] = mnc.subCriteriaWeight
                            delete mnc["subCriteriaName"];
                            delete mnc["subCriteriaWeight"];
                            evaluationCriteria.push(mnc)
                        }
                    }
                }
                else {
                    evaluationCriteria.push(obj)
                }
            })
            function formatter(value) {
                return `${Math.abs(value) + 1}`;
            }
            const { getFieldDecorator } = form; //can get the input value
            var children = [];
            //print all the criteria group of this MCA
            if (evaluationCriteria[ahpstep]) { //if criteria readed, push the current step of evaluation
                children.push(<h4 key={evaluationCriteria[ahpstep].criteriaName}><b>{evaluationCriteria[ahpstep].criteriaName}</b>
                    <div>&nbsp;</div>
                </h4>)
                for (var i = 0; i < projectAlternatives.length - 1; i++) {
                    for (var j = i + 1; j < projectAlternatives.length; j++) {
                        children.push(
                            <Row style={{ textAlign: "center" }} key={`${evaluationCriteria[ahpstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$e${projectAlternatives[j].alternativeName}`} type="flex" justify="space-around">
                                <Col span={4}>
                                    <p>{projectAlternatives[i].alternativeName}</p>
                                </Col>
                                <Col span={16}>
                                    <Form.Item  >
                                        {getFieldDecorator(`${evaluationCriteria[ahpstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$e${projectAlternatives[j].alternativeName}`, { initialValue: ahpData[ahpstep] ? ahpData[ahpstep][`${evaluationCriteria[ahpstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$e${projectAlternatives[j].alternativeName}`] : 0 })(
                                            <Slider marks={marks} included={false} tipFormatter={formatter} min={-8} max={8} step={1} />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={4}>
                                    <p>{projectAlternatives[j].alternativeName}</p>
                                </Col>
                            </Row>
                        );
                    }

                }
            }
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Evaluation elicitation"
                    onCancel={onCancel}
                    onOk={onCreate}
                    okButtonProps={{ disabled: ahpstep !== evaluationCriteria.length - 1 }}
                    width={800}
                    okText={"Finish"}
                >
                    <Form layout="vertical">
                        {children}
                    </Form>
                    <Row style={{ textAlign: "center" }} type="flex" justify="space-between" className="steps-action">

                        <Col span={8}><Button onClick={ahpPrevious} disabled={ahpstep === 0}>Previous</Button></Col>

                        <Col span={8} ><Button style={{ marginLeft: 8 }} disabled={ahpstep === evaluationCriteria.length - 1} onClick={ahpNext}>Next</Button></Col>
                    </Row>
                </Modal>
            );
        }

    }
);


//create SMART modal
const SMARTForm = Form.create({ name: 'form_in_modal' })(

    // eslint-disable-next-line
    class extends Component {
        render() {
            // const FormItem = Form.Item;

            const {
                visible, onCancel, onCreate, form, projectAlternatives, criteria, smartNext, smartPrevious, smartstep, smartData
            } = this.props; //read all the property send from criteria
            var evaluationCriteria = []
            const marks = {
                '0': '0',
                '1': '1',
                '2': '2',
                '3': '3',
                '4': '4',
                '5': '5',
                '6': '6',
                '7': '7',
                '8': '8',
                '9': '9',
                '10': '10'
            };
            criteria.forEach(obj => {
                if (obj.subCriteria && obj.subCriteria.length !== 0) {
                    if (obj.subCriteria.length === 1) {
                        var nc = JSON.parse(JSON.stringify(obj.subCriteria[0]));
                        nc["criteriaName"] = nc.subCriteriaName
                        nc["criteriaWeight"] = nc.subCriteriaWeight
                        delete nc["subCriteriaName"];
                        delete nc["subCriteriaWeight"]
                        evaluationCriteria.push(nc)
                    }
                    else {
                        for (var s in obj.subCriteria) {
                            var mnc = JSON.parse(JSON.stringify(obj.subCriteria[s]))
                            mnc["criteriaName"] = mnc.subCriteriaName
                            mnc["criteriaWeight"] = mnc.subCriteriaWeight
                            delete mnc["subCriteriaName"];
                            delete mnc["subCriteriaWeight"];
                            evaluationCriteria.push(mnc)
                        }
                    }
                }
                else {
                    evaluationCriteria.push(obj)
                }
            })
            function formatter(value) {
                return `${Math.abs(value)}`;
            }
            const { getFieldDecorator } = form; //can get the input value
            var scaleChildren = [];
            var directChildren = [];
            var title = "Title"
            var evaChildren = []
            //print all the criteria group of this MCA
            if (evaluationCriteria[smartstep]) { //if criteria readed, push the current step of evaluation
                title = evaluationCriteria[smartstep].criteriaName
                evaChildren.push(
                    <Form.Item style={{ textAlign: "center" }} key={`${evaluationCriteria[smartstep].criteriaName}`}>
                        {getFieldDecorator(`${evaluationCriteria[smartstep].criteriaName}`, {
                            initialValue: smartData[smartstep] ? smartData[smartstep][`${evaluationCriteria[smartstep].criteriaName}`] : "Scale",
                        })(
                            <Radio.Group>
                                <Radio value="Scale">10-Scale</Radio>
                            </Radio.Group>
                        )}
                    </Form.Item>
                )
                for (var i = 0; i < projectAlternatives.length; i++) {
                    scaleChildren.push(
                        <Row style={{ textAlign: "center" }} key={`${evaluationCriteria[smartstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$eScale`} type="flex" justify="space-around">
                            <Col span={4}>
                                <p>{projectAlternatives[i].alternativeName}</p>
                            </Col>
                            <Col span={16}>
                                <Form.Item  >
                                    {getFieldDecorator(`${evaluationCriteria[smartstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$eScale`, {
                                        initialValue: smartData[smartstep] && smartData[smartstep][`${evaluationCriteria[smartstep].criteriaName}`] === 'Scale' ? smartData[smartstep][`${evaluationCriteria[smartstep].criteriaName}W%m$e${projectAlternatives[i].alternativeName}W%m$eScale`] : 5
                                    })(
                                        <Slider marks={marks} max={10} min={0} tipFormatter={formatter} included={false} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col span={4}>
                            </Col>
                        </Row>
                    );
                }
            }
            return (
                <Modal
                    visible={visible} //control the showing of modal
                    title="Evaluation elicitation"
                    onCancel={onCancel}
                    onOk={onCreate}
                    okButtonProps={{ disabled: smartstep !== evaluationCriteria.length - 1 }}
                    width={800}
                    okText={"Finish"}
                >
                    <h4><b>{title}</b>
                        <div>&nbsp;</div>
                    </h4>
                    <Form layout="vertical">
                        {evaChildren}
                        {this.props.form.getFieldsValue()[title] === 'Direct' ? directChildren : scaleChildren}
                    </Form>
                    <Row style={{ textAlign: "center" }} type="flex" justify="space-between" className="steps-action">

                        <Col span={8}><Button onClick={smartPrevious} disabled={smartstep === 0}>Previous</Button></Col>

                        <Col span={8} ><Button style={{ marginLeft: 8 }} onClick={smartNext} disabled={smartstep === evaluationCriteria.length - 1}>Next</Button></Col>
                    </Row>
                </Modal>
            );
        }

    }
);

export default class MAMCAEvaluation extends Component {
    constructor(props) {
        super(props);
        const panes = [
            { title: 'Tab 1', key: '1' },
        ];

        let menu = ( //evaluator list default
            <Menu>
                <Menu.Item key="1">
                    <Icon type="user" />
                    1st menu item
                </Menu.Item>
                <Menu.Item key="2">
                    <Icon type="user" />
                    2nd menu item
                </Menu.Item>
                <Menu.Item key="3">
                    <Icon type="user" />
                    3rd item
                </Menu.Item>
            </Menu>
        );

        this.state = {
            activeKey: Cookie.get('activeKey'),
            email: Cookie.get("email"),
            projectActors: [],
            // MCAid: "",
            ahpVisible: false, //for ahp criteria modal
            smartVisible: false, //for SMART modal
            sisVisible: false, //for SIS modal
            loading: true, //the loading status default true
            project: {},
            ahpstep: 0,
            ahpData: [],
            smartstep: 0,
            smartData: [],
            sisstep: 0,
            sisData: [],
            criteria: [],
            projectAlternatives: [],
            column: [],
            data: [],
            panes,
            activeKey: '1',
            selectedEvaluator: Cookie.get("email"),
            menu: menu
        };
    }

    onStepChange = current => {
        if (current === 0) {
            this.props.history.push(`/alternative/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 1) {
            this.props.history.push(`/mamcaactors/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 2) {
            this.props.history.push(`/mamcacriteria/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 3) {
            this.props.history.push(`/mamcaweight/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
        if (current === 5) {
            this.props.history.push(`/mamcaresult/${this.props.match.params.projectid}`); //redirect to homepage if the project not exist, shouldn't be a case
        }
    }

    handleMenuClick = (e) => {
        var column = []
        var row = {}
        row.title = 'Alternative name'
        row.dataIndex = 'alternativeName'
        row.key = 'alternativeName'
        row.sorter = (a, b) => { if (a.alternativeName > b.alternativeName) { return -1; } if (a.alternativeName < b.alternativeName) { return 1; } return 0; }
        column.push(row)
        this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(obj => {
            var crow = {}
            if (obj.subCriteria && obj.subCriteria[0]) { //there is subcriteria
                let cW = 0
                obj.actors.forEach(aobj => {
                    if (aobj.actorEvaluator === e.key) { //find the evaluator
                        cW = aobj.actorCriteriaWeight
                        crow.title = obj.criteriaName + ` (` + (aobj.actorCriteriaWeight * 100).toFixed(0) + `%)`
                    }
                })
                var cChildren = []
                obj.subCriteria.forEach(subObj => {
                    var subrow = {}
                    subObj.actors.forEach(saobj => {
                        if (saobj.actorEvaluator === e.key) { //find the evaluator
                            subrow.title = subObj.subCriteriaName + ` (` + ((saobj.actorSubCriteriaWeight * cW) * 100).toFixed(0) + `%)`
                        }
                    })
                    subrow.dataIndex = subObj.subCriteriaName
                    subrow.key = subObj.subCriteriaName
                    subrow.sorter = (a, b) => { if (a[subObj.subCriteriaName] > b[subObj.subCriteriaName]) { return -1; } if (a[subObj.subCriteriaName] < b[subObj.subCriteriaName]) { return 1; } return 0; }
                    cChildren.push(subrow)
                })
                crow.children = cChildren
            }
            else { //no suubcriteria
                obj.actors.forEach(aobj => {
                    if (aobj.actorEvaluator === e.key) { //find the evaluator
                        crow.title = obj.criteriaName + ` (` + (aobj.actorCriteriaWeight * 100).toFixed(0) + `%)`
                    }
                })
                crow.dataIndex = obj.criteriaName
                crow.key = obj.criteriaName
                crow.sorter = (a, b) => { if (a[obj.criteriaName] > b[obj.criteriaName]) { return -1; } if (a[obj.criteriaName] < b[obj.criteriaName]) { return 1; } return 0; }
            }
            column.push(crow)
        })
        var erow = {}
        erow.title = 'Evaluation score'
        erow.dataIndex = 'alternativeScore'
        erow.key = 'alternativeScore'
        erow.sorter = (a, b) => { if (a.alternativeScore > b.alternativeScore) { return -1; } if (a.alternativeScore < b.alternativeScore) { return 1; } return 0; }
        column.push(erow)

        var data = []
        this.state.project.projectAlternatives.forEach(alternative => {
            var aData = {}
            var finalResult = 0;
            aData.key = alternative._id
            aData.alternativeName = alternative.alternativeName
            this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(obj => {
                if (obj.subCriteria && obj.subCriteria.length !== 0) { //there is sub-criterion
                    var pCriteriaWeight
                    obj.actors.forEach(Aobj => {
                        if (Aobj.actorEvaluator === e.key) {
                            pCriteriaWeight = Aobj.actorCriteriaWeight

                        }
                    })


                    obj.subCriteria.forEach(subobj => {
                        if (subobj.actors && subobj.actors.length !== 0) { //there is result
                            subobj.actors.forEach(asubobj => {
                                if (asubobj.actorEvaluator === e.key) { //find the evaluator
                                    asubobj.actorSubCriteriaResult.forEach(rasubobj => {
                                        if (rasubobj.subCriteriaAlternativeName === alternative.alternativeName) {
                                            aData[subobj.subCriteriaName] = rasubobj.subCriteriaAlternativeScore
                                            finalResult = pCriteriaWeight * asubobj.actorSubCriteriaWeight * rasubobj.subCriteriaAlternativeScore + finalResult
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
                else {
                    if (obj.actors && obj.actors.length !== 0) {
                        obj.actors.forEach(aobj => {
                            if (aobj.actorEvaluator === e.key) {
                                aobj.actorCriteriaResult.forEach(raobj => {
                                    if (raobj.criteriaAlternativeName === alternative.alternativeName) {
                                        aData[obj.criteriaName] = raobj.criteriaAlternativeScore
                                        finalResult = finalResult + raobj.criteriaAlternativeScore * aobj.actorCriteriaWeight
                                    }
                                })
                            }
                        })
                    }
                }

            })
            aData.alternativeScore = finalResult.toFixed(3);
            data.push(aData)
        })
        this.setState({
            column: column,
            data: data,
            selectedEvaluator: e.key,
            criteria: this.state.project.projectActorGroup[this.state.activeKey - 1].actorCriteria,
        });
    }


    onChange = (activeKey) => {
        this.setState({ activeKey });
        Cookie.set('activeKey', activeKey);
        this.formRef.props.form.resetFields(); //reset the form
        this.SformRef.props.form.resetFields(); //reset the form
        let menuList = []
        let menu
        if (this.state.project.projectActorGroup[activeKey - 1].actorCriteria[0]) {
            if (this.state.project.projectActorGroup[activeKey - 1].actorCriteria[0].actors && this.state.project.projectActorGroup[activeKey - 1].actorCriteria[0].actors.length !== 0) { //there are actors
                this.state.project.projectActorGroup[activeKey - 1].actorCriteria[0].actors.forEach(aobj => {
                    let menuItem = (
                        <Menu.Item key={aobj.actorEvaluator}>
                            <Icon type="user" />
                            {aobj.actorEvaluator}
                        </Menu.Item>
                    )
                    menuList.push(menuItem)
                })
            }
            menu = ( //evaluator list default
                <Menu onClick={this.handleMenuClick}>
                    {menuList}
                </Menu>
            );
        }
        else {
            menu = ( //evaluator list default
                <Menu onClick={this.handleMenuClick}>
                    <Menu.Item key={Cookie.get("email")}>
                        <Icon type="user" />
                        {Cookie.get("email")}
                    </Menu.Item>
                </Menu>
            )
        }

        var column = []
        var row = {}
        row.title = 'Alternative name'
        row.dataIndex = 'alternativeName'
        row.key = 'alternativeName'
        row.sorter = (a, b) => { if (a.alternativeName > b.alternativeName) { return -1; } if (a.alternativeName < b.alternativeName) { return 1; } return 0; }
        column.push(row)
        this.state.project.projectActorGroup[activeKey - 1].actorCriteria.forEach(obj => {
            var crow = {}
            if (obj.subCriteria && obj.subCriteria[0]) { //there is subcriteria
                let cW = 0
                obj.actors.forEach(aobj => {
                    if (aobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                        cW = aobj.actorCriteriaWeight
                        crow.title = obj.criteriaName + ` (` + (aobj.actorCriteriaWeight * 100).toFixed(0) + `%)`
                    }
                })
                var cChildren = []
                obj.subCriteria.forEach(subObj => {
                    var subrow = {}
                    subObj.actors.forEach(saobj => {
                        if (saobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                            subrow.title = subObj.subCriteriaName + ` (` + ((saobj.actorSubCriteriaWeight * cW) * 100).toFixed(0) + `%)`
                        }
                    })
                    subrow.dataIndex = subObj.subCriteriaName
                    subrow.key = subObj.subCriteriaName
                    subrow.sorter = (a, b) => { if (a[subObj.subCriteriaName] > b[subObj.subCriteriaName]) { return -1; } if (a[subObj.subCriteriaName] < b[subObj.subCriteriaName]) { return 1; } return 0; }
                    cChildren.push(subrow)
                })
                crow.children = cChildren
            }
            else { //no suubcriteria
                obj.actors.forEach(aobj => {
                    if (aobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                        crow.title = obj.criteriaName + ` (` + (aobj.actorCriteriaWeight * 100).toFixed(0) + `%)`
                    }
                })
                crow.dataIndex = obj.criteriaName
                crow.key = obj.criteriaName
                crow.sorter = (a, b) => { if (a[obj.criteriaName] > b[obj.criteriaName]) { return -1; } if (a[obj.criteriaName] < b[obj.criteriaName]) { return 1; } return 0; }
            }
            column.push(crow)
        })
        var erow = {}
        erow.title = 'Evaluation score'
        erow.dataIndex = 'alternativeScore'
        erow.key = 'alternativeScore'
        erow.sorter = (a, b) => { if (a.alternativeScore > b.alternativeScore) { return -1; } if (a.alternativeScore < b.alternativeScore) { return 1; } return 0; }
        column.push(erow)

        var data = []
        this.state.project.projectAlternatives.forEach(alternative => {
            var aData = {}
            var finalResult = 0;
            aData.key = alternative._id
            aData.alternativeName = alternative.alternativeName
            this.state.project.projectActorGroup[activeKey - 1].actorCriteria.forEach(obj => {
                if (obj.subCriteria && obj.subCriteria.length !== 0) { //there is sub-criterion
                    var pCriteriaWeight
                    obj.actors.forEach(Aobj => {
                        if (Aobj.actorEvaluator === Cookie.get("email")) {
                            pCriteriaWeight = Aobj.actorCriteriaWeight

                        }
                    })


                    obj.subCriteria.forEach(subobj => {
                        if (subobj.actors && subobj.actors.length !== 0) { //there is result
                            subobj.actors.forEach(asubobj => {
                                if (asubobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                                    asubobj.actorSubCriteriaResult.forEach(rasubobj => {
                                        if (rasubobj.subCriteriaAlternativeName === alternative.alternativeName) {
                                            aData[subobj.subCriteriaName] = rasubobj.subCriteriaAlternativeScore
                                            finalResult = pCriteriaWeight * asubobj.actorSubCriteriaWeight * rasubobj.subCriteriaAlternativeScore + finalResult
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
                else {
                    if (obj.actors && obj.actors.length !== 0) {
                        obj.actors.forEach(aobj => {
                            if (aobj.actorEvaluator === Cookie.get("email")) {
                                aobj.actorCriteriaResult.forEach(raobj => {
                                    if (raobj.criteriaAlternativeName === alternative.alternativeName) {
                                        aData[obj.criteriaName] = raobj.criteriaAlternativeScore
                                        finalResult = finalResult + raobj.criteriaAlternativeScore * aobj.actorCriteriaWeight
                                    }
                                })
                            }
                        })
                    }
                }

            })
            aData.alternativeScore = finalResult.toFixed(3);
            data.push(aData)
        })
        this.setState({
            activeKey,
            criteria: this.state.project.projectActorGroup[activeKey - 1].actorCriteria,
            column: column,
            data: data,
            ahpstep: 0,
            ahpData: [],
            smartstep: 0,
            smartData: [],
            MCAid: this.state.project.projectActorGroup[activeKey - 1]._id,
            selectedEvaluator: Cookie.get("email"),
            menu: menu
        });
    }

    //show or cancel ahp modal
    showAHPModal = () => {
        this.setState({ ahpVisible: true });
    }

    handleAHPCancel = () => {
        this.setState({ ahpVisible: false });
        // this.setState({ ahpstep: 0 });

    }
    ahpNext = () => {
        const form = this.formRef.props.form;
        var a = this.state.ahpData
        form.validateFields((err, values) => {
            a[this.state.ahpstep] = values
        })
        var s = this.state.ahpstep + 1
        this.setState({
            ahpstep: s,
            ahpData: a
        });
    }
    ahpPrevious = () => {
        const form = this.formRef.props.form;
        var a = this.state.ahpData
        form.validateFields((err, values) => {
            a[this.state.ahpstep] = values
        })
        var s = this.state.ahpstep - 1
        this.setState({
            ahpstep: s,
            ahpData: a
        });
    }

    //show or cancel SMART modal
    showSMARTModal = () => {
        this.setState({ smartVisible: true });
    }

    handleSMARTCancel = () => {
        this.setState({ smartVisible: false });
        // this.setState({ ahpstep: 0 });

    }
    //show or cancel SMART modal

    smartNext = () => {
        const form = this.SformRef.props.form;
        var a = this.state.smartData
        form.validateFields((err, values) => {
            a[this.state.smartstep] = values
        })
        var s = this.state.smartstep + 1
        this.setState({
            smartstep: s,
            smartData: a
        });
    }

    smartPrevious = () => {
        const form = this.SformRef.props.form;
        var a = this.state.smartData
        form.validateFields((err, values) => {
            a[this.state.smartstep] = values
        })
        var s = this.state.smartstep - 1
        this.setState({
            smartstep: s,
            smartData: a
        });
    }

    //show or cancel publish modal
    showPublishModal = () => {
        console.log(this.state.projectActors)
        this.setState({
            publishVisible: true,
            surveyLink: `https://mamca.vub.be/mamcaevaluationsurvey/${this.state.projectid}/${this.state.MCAid}`,
            stakeholderGroupName: this.state.projectActors.find(p => p._id === this.state.MCAid).actorGroupName
        });
    }
    handlePublishCancel = () => {
        this.setState({ publishVisible: false });
    }
    handleAHPEvaluation = () => {
        const form = this.formRef.props.form;
        var a = this.state.ahpData
        form.validateFields((err, values) => {
            a[this.state.ahpstep] = values
        })
        this.setState({
            ahpData: a
        });
        var evaluationResult = [] //the total evaluation result 
        a.forEach(values => { //for each evaluaion group
            var pairwiseRank = []
            for (var v in values) { //for each evaluation
                var match = v.split('W%m$e')
                var n = values[v]
                var c = match[0]
                if (n < 0) {
                    n = Math.abs(n) + 1 //convert to pairwise value
                }
                else {
                    n = 1 / (Math.abs(n) + 1)
                }
                match.push(n)
                pairwiseRank.push(match)
                match.shift()
            }
            const criteriaItem = [...new Set([].concat(...this.state.projectAlternatives.map(o => o.alternativeName)))]; //magic function for save unique array                  
            // const AHP = require('../ahp');
            var ahpContext = new AHP();
            ahpContext.addItems(criteriaItem);
            ahpContext.addCriteria([c]);
            //rank criteria with rank scale
            ahpContext.rankCriteriaItem(c, pairwiseRank);
            let output = ahpContext.run();
            var evaluationItem = {}
            evaluationItem.criteriaName = c
            evaluationItem.result = output.rankedScoreMap
            evaluationResult.push(evaluationItem)

        }
        )
        fetch('/project/evaluateMAMCAAHPSMART', { //REST create project
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: this.props.match.params.projectid,
                email: Cookie.get('email'),

                evaluationResult: evaluationResult,
                MCAid: this.state.MCAid,
            }),
        })
            .then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getProject();
                    message.success(json.message); //create successfully, show message
                    this.setState({
                        ahpVisible: false, //for ahp modal,
                        // ahpData: [], //comment for keeping the values
                        ahpstep: 0,
                        // smartData: [],
                        smartstep: 0,
                    }); //make modal invisible
                    // form.resetFields(); //reset the form
                }
                else {
                    message.error(json.message); //create unsuccessful, show alert
                }
            });
    }

    handleSMARTEvaluation = () => {
        const form = this.SformRef.props.form;
        var a = this.state.smartData
        form.validateFields((err, values) => {
            a[this.state.smartstep] = values
        })
        this.setState({
            smartData: a
        });
        var evaluationResult = [] //the total evaluation result 
        a.forEach(values => {
            // var eva = ""
            var evaluationItem = {}
            //  var totalScore = 0
            //  var totalNumber = 0
            var evaResult = {}
            for (var v in values) { //loop the evaluation
                var match = v.split('W%m$e')
                // var n = values[v] //get the value of object
                if (match.length === 1) {//this is the evaluation type
                    // eva = n //the evaluation type
                    evaluationItem.criteriaName = match[0]
                }
                else { //this is evaluation
                    // if (match[2] === eva) { //this is what we need to calculate
                    //     totalScore += n //add the score
                    //     totalNumber++
                    // }
                }
            }
            for (var i in values) {
                var vmatch = i.split('W%m$e')
                var o = values[i] //get the value of object
                // if (vmatch.length !== 1 && eva === vmatch[2]) { //calculate the weight
                //     if (totalScore === 0) { //average
                //         evaResult[`${vmatch[1]}`] = 1 / totalNumber
                //     }
                //     else {
                //         evaResult[`${vmatch[1]}`] = o / totalScore
                //     }
                // }
                evaResult[`${vmatch[1]}`] = o / 10
                evaluationItem.result = evaResult
            }
            evaluationResult.push(evaluationItem)
        })
        fetch('/project/evaluateMAMCAAHPSMART', { //REST create project
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: this.props.match.params.projectid,
                email: Cookie.get('email'),

                evaluationResult: evaluationResult,
                MCAid: this.state.MCAid,
            }),
        })
            .then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getProject();
                    message.success(json.message); //create successfully, show message
                    this.setState({
                        smartVisible: false, //for ahp modal,
                        // smartData: [],
                        smartstep: 0,
                        // ahpData: [],
                        ahpstep: 0
                    }); //make modal invisible
                    // form.resetFields(); //reset the form
                }
                else {
                    message.error(json.message); //create unsuccessful, show alert
                }
            });
    }
    handleSISEvaluation = () => {
        const form = this.SformRef.props.form;
        var a = this.state.sisData
        form.validateFields((err, values) => {
            a[this.state.sisstep] = values
        })
        this.setState({
            sisData: a
        });
        var evaluationResult = [] //the total evaluation result 
        a.forEach(values => {
            // var eva = ""
            var evaluationItem = {}
            //  var totalScore = 0
            //  var totalNumber = 0
            var evaResult = {}
            for (var v in values) { //loop the evaluation
                var match = v.split('W%m$e')
                // var n = values[v] //get the value of object
                if (match.length === 1) {//this is the evaluation type
                    // eva = n //the evaluation type
                    evaluationItem.criteriaName = match[0]
                }
                else { //this is evaluation
                    // if (match[2] === eva) { //this is what we need to calculate
                    //     totalScore += n //add the score
                    //     totalNumber++
                    // }
                }
            }
            for (var i in values) {
                var vmatch = i.split('W%m$e')
                var o = values[i] //get the value of object
                // if (vmatch.length !== 1 && eva === vmatch[2]) { //calculate the weight
                //     if (totalScore === 0) { //average
                //         evaResult[`${vmatch[1]}`] = 1 / totalNumber
                //     }
                //     else {
                //         evaResult[`${vmatch[1]}`] = o / totalScore
                //     }
                // }
                evaResult[`${vmatch[1]}`] = o / 10
                evaluationItem.result = evaResult
            }
            evaluationResult.push(evaluationItem)
        })
        fetch('/project/evaluateMAMCAAHPSMART', { //REST create project
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                uid: this.props.match.params.projectid,
                email: Cookie.get('email'),

                evaluationResult: evaluationResult,
                MCAid: this.state.MCAid,
            }),
        })
            .then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getProject();
                    message.success(json.message); //create successfully, show message
                    this.setState({
                        sisVisible: false, //for ahp modal,
                        // smartData: [],
                        sisstep: 0,
                        // ahpData: [],
                        ahpstep: 0
                    }); //make modal invisible
                    // form.resetFields(); //reset the form
                }
                else {
                    message.error(json.message); //create unsuccessful, show alert
                }
            });
    }

    //export template excel
    downloadTemplate = async () => {
        let ExcelHeaders = [ // Define headers
            { header: 'Alternative', key: 'alternativeName' },
        ];
        let data = []
        let projectData = {}
        let projectAlternatives = {}
        try {
            const response = await fetch(`/project/getProject/${this.props.match.params.projectid}/${Cookie.get("email")}/`, { //get the project id from link
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
            });
            const json = await response.json();
            if (json.success) {
                projectData = json.project.projectActorGroup.find(a => a._id === this.state.MCAid);
                projectAlternatives = json.project.projectAlternatives
            }
        } catch (error) {
            console.error("Error:", error);
        }
        projectAlternatives.forEach(a => {
            let oneData = { alternativeName: a.alternativeName }
            data.push(oneData); //First only add data for alternative names
        })
        // Check if fill there exist actor already

        let isFound = false // Find evaluator data
        if (Array.isArray(projectData.actorCriteria[0].subCriteria) && projectData.actorCriteria[0].subCriteria.length > 0) { // Has subcriteriin, so no need to care about criterion
            projectData.actorCriteria[0].subCriteria[0].actors.some(element => {
                if (element.actorEvaluator === this.state.email) { // There is selected evaluator
                    isFound = true;
                }
            })
        } else {
            projectData.actorCriteria[0].actors.some(element => {
                if (element.actorEvaluator === this.state.email) { // There is selected evaluator
                    isFound = true;
                }
            });
        }
        if (isFound) { // There might be data
            projectData.actorCriteria.forEach(c => { // First construct the header
                if (Array.isArray(c.subCriteria) && c.subCriteria.length > 0) { // Has subcriteria, so no need to care about criterion
                    c.subCriteria.forEach(child => { //For each subcriterion
                        ExcelHeaders.push({ header: child.subCriteriaName, key: child.subCriteriaName }) //Push the criterion as header
                        let selectedActor = child.actors.find(a => a.actorEvaluator === this.state.email) // Find the evaluator's data to push
                        if (Array.isArray(selectedActor.actorSubCriteriaResult) && selectedActor.actorSubCriteriaResult.length > 0) {// If there is result
                            selectedActor.actorSubCriteriaResult.forEach(a => { // Push the score
                                data.find(b => b.alternativeName === a.subCriteriaAlternativeName)[child.subCriteriaName] = a.subCriteriaAlternativeScore
                            })
                        } else { // Push 0
                            projectAlternatives.forEach(a => {
                                data.find(b => b.alternativeName === a.alternativeName)[child.subCriteriaName] = 0
                            })
                        }
                    })
                }
                else { // Only main criterion
                    ExcelHeaders.push({ header: c.criteriaName, key: c.criteriaName }) //Push the criterion as header
                    let selectedActor = c.actors.find(a => a.actorEvaluator === this.state.email) // Find the evaluator's data to push
                    if (Array.isArray(selectedActor.actorCriteriaResult) && selectedActor.actorCriteriaResult.length > 0) {// If there is result
                        selectedActor.actorCriteriaResult.forEach(a => { // Push the score
                            data.find(b => b.alternativeName === a.criteriaAlternativeName)[c.criteriaName] = a.criteriaAlternativeScore
                        })
                    } else { // Push 0
                        projectAlternatives.forEach(a => {
                            data.find(b => b.alternativeName === a.alternativeName)[c.criteriaName] = 0
                        })
                    }
                }
            })
        }
        else { // There is no data
            projectData.actorCriteria.forEach(c => {
                if (Array.isArray(c.subCriteria) && c.subCriteria.length > 0) { // Has subcriteria, so no need to care about criterion
                    c.subCriteria.forEach(child => { //For each subcriterion
                        ExcelHeaders.push({ header: child.subCriteriaName, key: child.subCriteriaName }) //Push the criterion as header
                        projectAlternatives.forEach(a => {
                            data.find(b => b.alternativeName === a.alternativeName)[child.subCriteriaName] = 0
                        })

                    })
                }
                else {
                    ExcelHeaders.push({ header: c.criteriaName, key: c.criteriaName }) //Push the criterion as header
                    projectAlternatives.forEach(a => {
                        data.find(b => b.alternativeName === a.alternativeName)[c.criteriaName] = 0
                    })
                }
            })
        }
        let fileType =
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let fileExtension = '.xlsx';


        let ws = XLSX.utils.json_to_sheet(data);
        let ws_with_headers = XLSX.utils.sheet_add_aoa(ws, [ExcelHeaders.map(h => h.header)], { origin: 'A1' });

        let wb = { Sheets: { data: ws_with_headers }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        let dataBlob = new Blob([excelBuffer], { type: fileType });
        saveAs(dataBlob, `MAMCA_Evaluation_Table${fileExtension}`);
    }

    //upload excel
    uploadExcel = (file) => {
        const reader = new FileReader();
        let data = {};
        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const workbook = XLSX.read(bstr, { type: 'binary' });

            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            data = XLSX.utils.sheet_to_json(worksheet);

            if (data && data.length > 0) { //if there is data
                // Change status here, if needed
                // Confirm upload with user
                if (window.confirm("Do you want to upload the evaluation result?")) {
                    // Confirm upload with user
                    fetch('/project/evaluateMAMCAExcel', { //REST create project
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            email: this.state.selectedEvaluator,
                            uid: this.props.match.params.projectid,
                            evaluationResult: data,
                            MCAid: this.state.MCAid,
                        }),
                    }).then(res => res.json())
                        .then(json => {
                            if (json.success) {
                                window.location.reload();
                            }
                            else {
                                message.error(json.message); //create unsuccessful, show alert
                            }
                        });
                }
            }
        };

        reader.readAsBinaryString(file);
        console.log(reader);

        // Prevent default upload behavior
        return false;
    }



    resetScore() {
        // var selectedEvaluatorCopy = (' ' + this.state.selectedEvaluator).slice(1);
        fetch('/project/resetScore', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: Cookie.get("email"),
                actid: this.state.MCAid,
                selectedEvaluator: this.state.selectedEvaluator
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getEvaProject(); //if success, refresh the criteria list
                    // this.setState({ 
                    //     selectedEvaluator:selectedEvaluatorCopy
                    // })
                    message.success(json.message); //delete successful, show message
                }
                else {
                    message.error(json.message); //delete unsuccessful, show alert
                }
            });

    }
    copyScore() {
        // var selectedEvaluatorCopy = (' ' + this.state.selectedEvaluator).slice(1);
        fetch('/project/copyProjectManagerScore', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email: Cookie.get("email"),
                actid: this.state.MCAid,
                selectedEvaluator: this.state.selectedEvaluator
            }),
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    this.getEvaProject(); //if success, refresh the criteria list
                    // this.setState({ 
                    //     selectedEvaluator:selectedEvaluatorCopy
                    // })
                    message.success(json.message); //delete successful, show message
                }
                else {
                    message.error(json.message); //delete unsuccessful, show alert
                }
            });

    }
    //get the projects
    getProject = () => {
        fetch(`/project/getProject/${this.props.match.params.projectid}/${Cookie.get("email")}/`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    let panes = []
                    let index = 1
                    json.project.projectActorGroup.forEach(obj => {
                        panes.push({ title: obj.actorGroupName, key: index, id: obj._id })
                        index++
                    })
                    let menuList = []
                    if (json.project.projectActorGroup && json.project.projectActorGroup.length !== 0) {
                        if (json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria && json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.length !== 0) {
                            if (json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria[0].actors && json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria[0].actors.length !== 0) { //there are actors
                                json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria[0].actors.forEach(aobj => {
                                    let menuItem = (
                                        <Menu.Item key={aobj.actorEvaluator}>
                                            <Icon type="user" />
                                            {aobj.actorEvaluator}
                                        </Menu.Item>
                                    )
                                    menuList.push(menuItem)
                                })
                            }
                        }


                        let menu = ( //evaluator list default
                            <Menu onClick={this.handleMenuClick}>
                                {menuList}
                            </Menu>
                        );

                        var column = []
                        var row = {}
                        row.title = 'Alternative name'
                        row.dataIndex = 'alternativeName'
                        row.key = 'alternativeName'
                        row.sorter = (a, b) => { if (a.alternativeName > b.alternativeName) { return -1; } if (a.alternativeName < b.alternativeName) { return 1; } return 0; }
                        column.push(row)
                        if (json.project.projectActorGroup && json.project.projectActorGroup.length !== 0) {
                            json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(obj => {
                                var crow = {}
                                if (obj.subCriteria && obj.subCriteria[0]) { //there is subcriteria
                                    let cW = 0 //criteria weight for the sub criteria
                                    obj.actors.forEach(aobj => {
                                        if (aobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                                            cW = aobj.actorCriteriaWeight
                                            crow.title = obj.criteriaName + ` (` + (aobj.actorCriteriaWeight * 100).toFixed(0) + `%)`
                                        }
                                    })
                                    var cChildren = []
                                    obj.subCriteria.forEach(subObj => {
                                        var subrow = {}
                                        subObj.actors.forEach(saobj => {
                                            if (saobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                                                subrow.title = subObj.subCriteriaName + ` (` + ((saobj.actorSubCriteriaWeight * cW) * 100).toFixed(0) + `%)`
                                            }
                                        })
                                        subrow.dataIndex = subObj.subCriteriaName
                                        subrow.key = subObj.subCriteriaName
                                        subrow.sorter = (a, b) => { if (a[subObj.subCriteriaName] > b[subObj.subCriteriaName]) { return -1; } if (a[subObj.subCriteriaName] < b[subObj.subCriteriaName]) { return 1; } return 0; }
                                        cChildren.push(subrow)
                                    })
                                    crow.children = cChildren
                                }
                                else { //no suubcriteria
                                    obj.actors.forEach(aobj => {
                                        if (aobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                                            crow.title = obj.criteriaName + ` (` + (aobj.actorCriteriaWeight * 100).toFixed(0) + `%)`
                                        }
                                    })
                                    crow.dataIndex = obj.criteriaName
                                    crow.key = obj.criteriaName
                                    crow.sorter = (a, b) => { if (a[obj.criteriaName] > b[obj.criteriaName]) { return -1; } if (a[obj.criteriaName] < b[obj.criteriaName]) { return 1; } return 0; }
                                }
                                column.push(crow)
                            })
                        }

                        var erow = {}
                        erow.title = 'Evaluation score'
                        erow.dataIndex = 'alternativeScore'
                        erow.key = 'alternativeScore'
                        erow.sorter = (a, b) => { if (a.alternativeScore > b.alternativeScore) { return -1; } if (a.alternativeScore < b.alternativeScore) { return 1; } return 0; }
                        column.push(erow)

                        var data = []
                        json.project.projectAlternatives.forEach(alternative => {
                            var aData = {}
                            var finalResult = 0
                            aData.key = alternative._id
                            aData.alternativeName = alternative.alternativeName
                            json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(obj => {
                                if (obj.subCriteria && obj.subCriteria.length !== 0) { //there is sub-criterion
                                    var pCriteriaWeight
                                    obj.actors.forEach(Aobj => {
                                        if (Aobj.actorEvaluator === Cookie.get("email")) {
                                            pCriteriaWeight = Aobj.actorCriteriaWeight

                                        }
                                    })
                                    obj.subCriteria.forEach(subobj => {
                                        if (subobj.actors && subobj.actors.length !== 0) { //there is result
                                            subobj.actors.forEach(asubobj => {
                                                if (asubobj.actorEvaluator === Cookie.get("email")) { //find the evaluator
                                                    asubobj.actorSubCriteriaResult.forEach(rasubobj => {
                                                        if (rasubobj.subCriteriaAlternativeName === alternative.alternativeName) {
                                                            aData[subobj.subCriteriaName] = rasubobj.subCriteriaAlternativeScore
                                                            finalResult = pCriteriaWeight * asubobj.actorSubCriteriaWeight * rasubobj.subCriteriaAlternativeScore + finalResult
                                                        }

                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                                else {
                                    if (obj.actors && obj.actors.length !== 0) {
                                        obj.actors.forEach(aobj => {
                                            if (aobj.actorEvaluator === Cookie.get("email")) {
                                                aobj.actorCriteriaResult.forEach(raobj => {
                                                    if (raobj.criteriaAlternativeName === alternative.alternativeName) {
                                                        aData[obj.criteriaName] = raobj.criteriaAlternativeScore
                                                        finalResult = finalResult + raobj.criteriaAlternativeScore * aobj.actorCriteriaWeight
                                                    }
                                                })
                                            }
                                        })
                                    }
                                }

                            })
                            aData.alternativeScore = finalResult.toFixed(3);
                            data.push(aData)
                        })
                        this.setState({
                            project: json.project,
                            projectActors: json.project.projectActorGroup,
                            projectName: json.project.projectName,
                            projectType: json.project.projectType,
                            projectEvaluationType: json.project.projectEvaluationType,
                            projectAlternatives: json.project.projectAlternatives,
                            criteria: json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria,
                            MCAid: json.project.projectActorGroup[this.state.activeKey - 1]._id,
                            projectid: json.project._id,
                            loading: false,
                            column: column,
                            data: data,
                            panes: panes,
                            menu: menu,
                        }) //save project data
                    }
                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }

    //get the projects
    getEvaProject = () => {
        fetch(`/project/getProject/${this.props.match.params.projectid}/${Cookie.get("email")}/`, { //get the project id from link
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
        }).then(res => res.json())
            .then(json => {
                if (json.success) {
                    let panes = []
                    let index = 1
                    json.project.projectActorGroup.forEach(obj => {
                        panes.push({ title: obj.actorGroupName, key: index, id: obj._id })
                        index++
                    })
                    let menuList = []
                    if (json.project.projectActorGroup && json.project.projectActorGroup.length !== 0) {
                        if (json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria && json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.length !== 0) {
                            if (json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria[0].actors && json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria[0].actors.length !== 0) { //there are actors
                                json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria[0].actors.forEach(aobj => {
                                    let menuItem = (
                                        <Menu.Item key={aobj.actorEvaluator}>
                                            <Icon type="user" />
                                            {aobj.actorEvaluator}
                                        </Menu.Item>
                                    )
                                    menuList.push(menuItem)
                                })
                            }
                        }


                        let menu = ( //evaluator list default
                            <Menu onClick={this.handleMenuClick}>
                                {menuList}
                            </Menu>
                        );

                        var column = []
                        var row = {}
                        row.title = 'Alternative name'
                        row.dataIndex = 'alternativeName'
                        row.key = 'alternativeName'
                        row.sorter = (a, b) => { if (a.alternativeName > b.alternativeName) { return -1; } if (a.alternativeName < b.alternativeName) { return 1; } return 0; }
                        column.push(row)
                        if (json.project.projectActorGroup && json.project.projectActorGroup.length !== 0) {
                            json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(obj => {
                                var crow = {}
                                if (obj.subCriteria && obj.subCriteria[0]) { //there is subcriteria
                                    let cW = 0 //criteria weight for the sub criteria
                                    obj.actors.forEach(aobj => {
                                        if (aobj.actorEvaluator === this.state.selectedEvaluator) { //find the evaluator
                                            cW = aobj.actorCriteriaWeight
                                            crow.title = obj.criteriaName + ` (` + (aobj.actorCriteriaWeight * 100).toFixed(0) + `%)`
                                        }
                                    })
                                    var cChildren = []
                                    obj.subCriteria.forEach(subObj => {
                                        var subrow = {}
                                        subObj.actors.forEach(saobj => {
                                            if (saobj.actorEvaluator === this.state.selectedEvaluator) { //find the evaluator
                                                subrow.title = subObj.subCriteriaName + ` (` + ((saobj.actorSubCriteriaWeight * cW) * 100).toFixed(0) + `%)`
                                            }
                                        })
                                        subrow.dataIndex = subObj.subCriteriaName
                                        subrow.key = subObj.subCriteriaName
                                        subrow.sorter = (a, b) => { if (a[subObj.subCriteriaName] > b[subObj.subCriteriaName]) { return -1; } if (a[subObj.subCriteriaName] < b[subObj.subCriteriaName]) { return 1; } return 0; }
                                        cChildren.push(subrow)
                                    })
                                    crow.children = cChildren
                                }
                                else { //no suubcriteria
                                    obj.actors.forEach(aobj => {
                                        if (aobj.actorEvaluator === this.state.selectedEvaluator) { //find the evaluator
                                            crow.title = obj.criteriaName + ` (` + (aobj.actorCriteriaWeight * 100).toFixed(0) + `%)`
                                        }
                                    })
                                    crow.dataIndex = obj.criteriaName
                                    crow.key = obj.criteriaName
                                    crow.sorter = (a, b) => { if (a[obj.criteriaName] > b[obj.criteriaName]) { return -1; } if (a[obj.criteriaName] < b[obj.criteriaName]) { return 1; } return 0; }
                                }
                                column.push(crow)
                            })
                        }

                        var erow = {}
                        erow.title = 'Evaluation score'
                        erow.dataIndex = 'alternativeScore'
                        erow.key = 'alternativeScore'
                        erow.sorter = (a, b) => { if (a.alternativeScore > b.alternativeScore) { return -1; } if (a.alternativeScore < b.alternativeScore) { return 1; } return 0; }
                        column.push(erow)

                        var data = []
                        json.project.projectAlternatives.forEach(alternative => {
                            var aData = {}
                            var finalResult = 0
                            aData.key = alternative._id
                            aData.alternativeName = alternative.alternativeName
                            json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria.forEach(obj => {
                                if (obj.subCriteria && obj.subCriteria.length !== 0) { //there is sub-criterion
                                    var pCriteriaWeight
                                    obj.actors.forEach(Aobj => {
                                        if (Aobj.actorEvaluator === this.state.selectedEvaluator) {
                                            pCriteriaWeight = Aobj.actorCriteriaWeight

                                        }
                                    })
                                    obj.subCriteria.forEach(subobj => {
                                        if (subobj.actors && subobj.actors.length !== 0) { //there is result
                                            subobj.actors.forEach(asubobj => {
                                                if (asubobj.actorEvaluator === this.state.selectedEvaluator) { //find the evaluator
                                                    asubobj.actorSubCriteriaResult.forEach(rasubobj => {
                                                        if (rasubobj.subCriteriaAlternativeName === alternative.alternativeName) {
                                                            aData[subobj.subCriteriaName] = rasubobj.subCriteriaAlternativeScore
                                                            finalResult = pCriteriaWeight * asubobj.actorSubCriteriaWeight * rasubobj.subCriteriaAlternativeScore + finalResult
                                                        }

                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                                else {
                                    if (obj.actors && obj.actors.length !== 0) {
                                        obj.actors.forEach(aobj => {
                                            if (aobj.actorEvaluator === this.state.selectedEvaluator) {
                                                aobj.actorCriteriaResult.forEach(raobj => {
                                                    if (raobj.criteriaAlternativeName === alternative.alternativeName) {
                                                        aData[obj.criteriaName] = raobj.criteriaAlternativeScore
                                                        finalResult = finalResult + raobj.criteriaAlternativeScore * aobj.actorCriteriaWeight
                                                    }
                                                })
                                            }
                                        })
                                    }
                                }

                            })
                            aData.alternativeScore = finalResult.toFixed(3);
                            data.push(aData)
                        })
                        this.setState({
                            project: json.project,
                            projectName: json.project.projectName,
                            projectType: json.project.projectType,
                            projectActors: json.project.projectActorGroup,
                            projectEvaluationType: json.project.projectEvaluationType,
                            projectAlternatives: json.project.projectAlternatives,
                            criteria: json.project.projectActorGroup[this.state.activeKey - 1].actorCriteria,
                            MCAid: json.project.projectActorGroup[this.state.activeKey - 1]._id,
                            loading: false,
                            column: column,
                            data: data,
                            panes: panes,
                            menu: menu,
                        }) //save project data
                    }
                }
                else {
                    message.error(json.message)
                    this.props.history.push("/"); //redirect to homepage if the project not exist, shouldn't be a case
                }
            });
    }



    //save all the form data of create
    saveFormRef = (formRef) => {
        this.formRef = formRef;
    }

    saveSFormRef = (formRef) => {
        this.SformRef = formRef;
    }

    //save all the form data of publish
    savePFormRef = (formRef) => {
        this.PformRef = formRef;
    }
    componentDidMount() {
        try {
            this.setState({ activeKey: Cookie.get('activeKey') })
            this.getProject() //after render immediately get alternative list
        } catch (e) {
            alert(e);
        }
    }

    render() {


        const Step = Steps.Step;
        //the step infomation
        const mamcaSteps = [{
            title: 'Alternatives',
        },
        {
            title: 'Actors',
        }, {
            title: 'Criteria',
        }, {
            title: 'Weights',
        }, {
            title: 'Evaluation',
        }, {
            title: 'Result',
        }];

        return <div className="MCACriteria">
            <Spin size="large" tip="Loading..." spinning={this.state.loading}>
                <Row style={{ marginTop: "5vh" }} type="flex" justify="space-around">
                    <h3>{this.state.projectName}</h3>
                </Row>
                <Divider />
                <Steps style={{ width: "80%", margin: "auto" }} current={4} onChange={this.onStepChange}>
                    {mamcaSteps.map(item => <Step key={item.title} title={item.title} />)}
                </Steps>
                <div className="steps-content"></div>
                <Tabs
                    size={"large"}
                    onChange={this.onChange}
                    activeKey={this.state.activeKey}
                >
                    {this.state.panes.map(pane => <TabPane tab={<span><Icon type="team" />{pane.title}</span>} key={pane.key}></TabPane>)}
                </Tabs>
                {this.state.projectEvaluationType === "AHP" && this.state.selectedEvaluator === Cookie.get("email") ?
                    <Button style={{ marginLeft: "0" }} type="primary" size="large" onClick={this.showAHPModal}>AHP Evaluation</Button> :
                    this.state.projectEvaluationType === "SMART" && this.state.selectedEvaluator === Cookie.get("email") ?
                        <Button style={{ marginLeft: "2vh" }} type="primary" size="large" onClick={this.showSMARTModal}>SMART Evaluation</Button> :
                        this.state.projectEvaluationType === "Predefined" && this.state.selectedEvaluator === Cookie.get("email") ?
                            <span><Button style={{ marginLeft: "0" }} type="primary" size="large" onClick={this.showAHPModal}>AHP Evaluation</Button>
                                <Button style={{ marginLeft: "2vh" }} type="primary" size="large" onClick={this.showSMARTModal}>SMART Evaluation</Button></span>
                            :
                            <Button style={{ marginLeft: "0" }} type="primary" size="large" onClick={() => { this.copyScore() }}>Copy your score to this stakeholder</Button>}
                <Popconfirm title="Are you sure you want to clear the evaluation of this stakeholder?" onConfirm={() => { this.resetScore() }} okText="Yes" cancelText="No">
                    <Button style={{ marginLeft: "2vh" }} size="large">Reset</Button>
                </Popconfirm>
                {this.state.projectEvaluationType === "AHP" ? <span></span> : <Button style={{ marginLeft: "2vh" }} type="primary" size="large" onClick={this.showPublishModal}>Alternative apprasial survey</Button>}
                <Dropdown.Button style={{ float: "right" }} type="primary" size="large" overlay={this.state.menu} icon={<Icon type="user" />}>
                    {this.state.selectedEvaluator}
                </Dropdown.Button>
                <Divider />
                <Text>Use excel to downlaod/upload data:&nbsp;</Text>
                <Button style={{ marginLeft: "0" }} onClick={this.downloadTemplate} > Download data in Excel</Button>

                <Upload accept=".xlsx,.xls" customRequest={({ file }) => this.uploadExcel(file)}>
                    <Button style={{ marginLeft: 8 }} type="primary" > Upload your data in Excel format</Button>
                </Upload>
                <div>&nbsp;</div>
                <ConfigProvider renderEmpty={() => <Empty />}>
                    <Table
                        columns={this.state.column}
                        dataSource={this.state.data}
                        bordered
                        scroll={{ x: 'max-content' }} // Enable horizontal scrolling
                    />
                </ConfigProvider>
                <Divider />
                {/* {this.state.project.projectEvaluated ? <div /> : <p>You have to evaluate to continue</p>} */}
                <div className="steps-action">
                    {/* disabled={!this.state.project.projectEvaluated} */}
                    <Button size="large" type="primary" >
                        <Link to={`/mamcaresult/${this.props.match.params.projectid}`}>Result</Link></Button>
                    <Button size="large" style={{ marginLeft: 8 }}>
                        <Link to={`/mamcaweight/${this.props.match.params.projectid}`}>Previous</Link></Button>
                </div>
            </Spin>
            <AHPForm
                wrappedComponentRef={this.saveFormRef}
                visible={this.state.ahpVisible}
                onCancel={this.handleAHPCancel}
                onCreate={this.handleAHPEvaluation}
                projectAlternatives={this.state.projectAlternatives} //send alternatives
                criteria={this.state.criteria}
                ahpstep={this.state.ahpstep}
                ahpNext={this.ahpNext}
                ahpPrevious={this.ahpPrevious}
                ahpData={this.state.ahpData}
            />
            <SMARTForm
                wrappedComponentRef={this.saveSFormRef}
                visible={this.state.smartVisible}
                onCancel={this.handleSMARTCancel}
                onCreate={this.handleSMARTEvaluation}
                projectAlternatives={this.state.projectAlternatives} //send alternatives
                criteria={this.state.criteria}
                smartstep={this.state.smartstep}
                smartNext={this.smartNext}
                smartPrevious={this.smartPrevious}
                smartData={this.state.smartData}
            />
            <PublishForm
                wrappedComponentRef={this.savePFormRef}
                visible={this.state.publishVisible}
                onCancel={this.handlePublishCancel}
                onCreate={this.handlePublishCancel}
                actor={this.state.stakeholderGroupName}
                surveyLink={this.state.surveyLink}
            />
        </div>;
    }
}